import type { CategoryStyles } from '~/features/category';
import { tw } from '~/utils';

export const categoryStyles = tw<CategoryStyles>({
  base: 'grid grid-cols-4 gap-2 md:grid-cols-6',
  item: '',
  link: 'border-grey-100 text-caption-m hover:border-grey-950 focus-visible:outline-grey-950 flex size-full flex-col items-center justify-center rounded border px-1 py-4 transition-colors focus-visible:outline-offset-4 md:px-4',
  name: 'flex h-[42px] items-center justify-center text-center leading-[1.3]',
  icon: 'h-[33px] w-[33px]',
});
